import React, { useContext } from 'react';
import { ConfirmationServiceContext } from '../providers/ConfirmationProvider';

/**
 * Confirmation window's useConfirmation hook
 * @returns {(options: ConfirmationOptions) => Promise<void>}
 */
export const useConfirmation = () => useContext(ConfirmationServiceContext);
